var _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructurePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 22,
    r: 20,
    fill: "url(#paint0_linear_91_3624)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 22,
    r: 20.75,
    stroke: "#FEFEFE",
    strokeOpacity: 0.3,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2304 29.8192C21.0437 29.8192 20.8851 29.7632 20.7544 29.6512C20.6424 29.5205 20.5864 29.3618 20.5864 29.1752V23.3512H14.8464C14.6597 23.3512 14.5011 23.2952 14.3704 23.1832C14.2584 23.0525 14.2024 22.8938 14.2024 22.7072V21.8112C14.2024 21.6245 14.2584 21.4752 14.3704 21.3632C14.5011 21.2325 14.6597 21.1672 14.8464 21.1672H20.5864V15.5112C20.5864 15.3245 20.6424 15.1752 20.7544 15.0632C20.8851 14.9325 21.0437 14.8672 21.2304 14.8672H22.2104C22.3971 14.8672 22.5464 14.9325 22.6584 15.0632C22.7891 15.1752 22.8544 15.3245 22.8544 15.5112V21.1672H28.6224C28.8091 21.1672 28.9584 21.2325 29.0704 21.3632C29.2011 21.4752 29.2664 21.6245 29.2664 21.8112V22.7072C29.2664 22.8938 29.2011 23.0525 29.0704 23.1832C28.9584 23.2952 28.8091 23.3512 28.6224 23.3512H22.8544V29.1752C22.8544 29.3618 22.7891 29.5205 22.6584 29.6512C22.5464 29.7632 22.3971 29.8192 22.2104 29.8192H21.2304Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_3624",
    x1: 2.75,
    y1: 2.57143,
    x2: 19.4307,
    y2: 49.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58E35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503297,
    stopColor: "#F26C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE288A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructurePlus);
export default __webpack_public_path__ + "static/media/StructurePlus.89069e6aec5c37976b1d7df93b3e9594.svg";
export { ForwardRef as ReactComponent };